import styled, { css } from 'styled-components';

export const ComparePlanButtonSelectionStyled = styled.div.attrs(() => ({
  className: 'card-button-selection',
}))`
  ${({ theme }) => {
    const { fonts, media, colors } = theme;
    return css`
      &.card-button-selection {
        font-family: ${fonts.objectSans};
        display: flex;
        flex: 1;
        padding: 24px 0 24px 0;
        flex-direction: column;
        align-items: flex-start;
        gap: 35px;
        align-self: stretch;
        background: ${colors.primary.white};
        ${media.mobile.down} {
          padding: 16px 8px 8px 8px;
          gap: 12px;
        }
        .plan-name {
          display: flex;
          align-items: flex-end;
          align-self: stretch;
          h4 {
            color: ${colors.primary.darkBlue};
            font-size: 24px;
            font-style: normal;
            font-weight: 500;
            line-height: 28px;
            ${media.mobile.down} {
              font-size: 16px;
              line-height: 20px;
            }
          }
        }
        .btn-select-plan-compare {
          display: flex;
          align-items: flex-start;
          ${media.desktop.up} {
            max-width: 33%;
          }
          ${media.tablet.down} {
            max-width: 60%;
          }
          button {
            display: flex;
            padding: var(--padding-padding-sm, 8px) var(--padding-padding-2xl, 32px);
            justify-content: center;
            align-items: center;
            gap: var(--spacing-spacing-sm, 8px);
          }
        }
      }
    `;
  }}
`;
export default ComparePlanButtonSelectionStyled;
